import React from "react";
import Context from "../../../Context";
import StaffListRow from "./StaffListRow";
import List from "../../Misc/List";
import FieldsList from "../../Misc/FieldsList";
import Sortings from "../../Misc/Sortings";
import Filters from "../../Misc/Filters";
import { Link } from "react-router-dom";
import { essenceClass } from "../../../essense";
import Searchbox from "../../Misc/Searchbox";

let searchTimeout = null;

export default class StaffList extends React.Component {
  static contextType = Context;
  static fieldsStorageName = "staffListFields";
  constructor(props) {
    super(props);
    let savedFields = localStorage.getItem(this.fieldsStorageName)
      ? JSON.parse(localStorage.getItem(this.fieldsStorageName))
      : [];
    this.state = {
      listKey: "",
      pending: false,
      searchPending: false,
      search: [],
      filters: {
        show: false,
        active: [],
        all: [
          {
            id: "created",
            title: "По дате создания",
            kind: "range",
            active: false,
            value: [],
          },
        ],
      },
      fields: {
        all: [
          "id",
          "username",
          "name",
          "description",
          "phone",
          "email",
          "status",
        ],
        active: savedFields,
      },
      sortings: {
        all: [
          {
            id: "byFullnameAsc",
            active: false,
            title: "По ФИО",
            value: ["fullname ASC"],
          },
          {
            id: "byCreatedDesc",
            active: false,
            title: "По дате создания",
            value: ["created DESC"],
          },
        ],
        active: [],
      },
    };
  }
  componentDidMount() {
    this.loadInfo();
  }

  loadInfo = async () => {
    let essence = new essenceClass("staff");

    let stateList = await essence.getStateList();
    if (Array.isArray(stateList)) {
      let variants = [];
      stateList.forEach((item) =>
        variants.push([
          item.label,
          [{ field: "statecode", compare: "EQL", value: item.code }],
        ])
      );
      this.setState((state) => {
        let filters = state.filters;
        filters.all.push({
          id: "statecode",
          title: "По статусу",
          kind: "dropdown",
          multiple: true,
          active: false,
          activeVariants: [],
          variants,
        });
        return { filters };
      });
    }

    let positionList = await this.context.api.qa("/position/list", {
      search: [
        {
          field: "statetypecode",
          compare: "EQL",
          value: "enabled",
        },
      ],
    });
    if (Array.isArray(positionList)) {
      let variants = [];
      positionList.forEach((item) =>
        variants.push([
          item.name,
          [{ field: "positioncode", compare: "EQL", value: item.code }],
        ])
      );
      this.setState((state) => {
        let filters = state.filters;
        filters.all.push({
          id: "typecode",
          title: "По должности",
          kind: "dropdown",
          multiple: true,
          active: false,
          activeVariants: [],
          variants,
        });
        return { filters };
      });
    }

    let areaList = await this.context.api.qa("/member/area");
    if (Array.isArray(areaList)) {
      let variants = [];
      areaList.forEach((item) => {
        if (item.typecode !== "root") {
          variants.push([
            item.name,
            [{ field: "area", compare: "EQL", value: item.id }],
          ]);
        }
      });
      this.setState((state) => {
        let filters = state.filters;
        filters.all.push({
          id: "area",
          title: "По подразделению",
          kind: "dropdown",
          multiple: false,
          active: false,
          activeVariants: [],
          variants,
        });
        return { filters };
      });
    }
  };

  toggleFilters = (v) => {
    this.setState((state) => {
      let filters = state.filters;
      filters.show = v;
      return { filters };
    });
  };

  handleFilters = (changedFilters) => {
    this.setState((state) => {
      let filters = state.filters;
      filters.active = changedFilters;
      return { filters };
    });
  };
  handleFields = (changedFields) => {
    localStorage.setItem(this.fieldsStorageName, JSON.stringify(changedFields));
    this.setState((state) => {
      let fields = state.fields;
      fields.active = changedFields;
      return { fields };
    });
  };
  handleSortings = (chnagedSortings) => {
    this.setState((state) => {
      let sortings = state.sortings;
      sortings.active = chnagedSortings;
      return { sortings };
    });
  };
  handleSearch = (searchValue) => {
    let search = searchValue
      ? [
          {
            lstr: "(",
            field: "fullname",
            compare: "IKE",
            value: `%${searchValue}%`,
          },
          {
            field: "structurename",
            compare: "IKE",
            value: `%${searchValue}%`,
            condition: "OR",
          },
          {
            field: "positionname",
            compare: "IKE",
            value: `%${searchValue}%`,
            condition: "OR",
            rstr: ")",
          },
        ]
      : [];
    this.setState({ search });
  };

  onMethodFinish = () => {
    this.setState({ listKey: this.context.key() });
  };

  render() {
    let filters = (
      <div
        className={`${
          this.state.filters.show ? "d-flex" : "d-none"
        }  align-items-center justify-content-end mt-0 py-5 px-7 mb-2 border-bottom w-100 shadow-sm`}
      >
        <Filters
          key={JSON.stringify(this.state.filters.all)}
          changeFn={this.handleFilters}
          filters={this.state.filters.all}
        />
      </div>
    );
    let access = this.context.user.classAccess.staff || {};
    return (
      <>
        <div className="card card-custom gutter-b ">
          <div className="card-header">
            <div className="card-title w-100 mr-0 p-lg-0 py-5 d-block d-lg-flex align-items-center justify-content-between">
              <h3>Сотрудники</h3>
              <div>
                <div className="text-nowrap d-inline-block mr-2">
                  <Searchbox onSearch={this.handleSearch} />
                </div>
                {access.c === true ? (
                  <Link
                    to="/staff/add/"
                    className="btn btn-light mr-2 text-hover-primary"
                  >
                    <i className="flaticon2-add-1 p-0 align-middle text-muted"></i>
                  </Link>
                ) : null}

                {false ? (
                  <FieldsList
                    changeFn={this.handleFields}
                    fields={this.state.fields.all}
                    activeFields={this.state.fields.active}
                  />
                ) : null}

                <button
                  className="btn btn-light mr-2"
                  onClick={() => this.toggleFilters(!this.state.filters.show)}
                >
                  <i
                    className={`fa fa-filter p-0 ${
                      this.state.filters.show ? "text-primary" : "text-muted"
                    }`}
                  ></i>
                </button>
                <Sortings
                  changeFn={this.handleSortings}
                  sortings={this.state.sortings.all}
                />
              </div>
            </div>
          </div>
          {filters}
          <div className="card-body">
            <List
              listKey={"staff"}
              key={this.state.listKey}
              fulltext={JSON.stringify(this.state.search)}
              search={JSON.stringify(this.state.filters.active)}
              sort={JSON.stringify(this.state.sortings.active)}
              fields={JSON.stringify(this.state.fields.active)}
              limit={20}
              keyField="id"
              path="/staff/list"
              multiselect
            >
              <StaffListRow onFinish={this.onMethodFinish} />
            </List>
          </div>
        </div>
      </>
    );
  }
}
